import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";
import type { CustomHtmlEditorProps } from "./Editor";

const CustomHtmlEditorComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "CustomHtmlEditorComponent" */ "@circle-react/components/shared/BuilderUI/Editor/fields/CustomHTMLEditor/Editor"
    ),
);

export const CustomHtmlEditor = (props: CustomHtmlEditorProps) => (
  <Suspense fallback={<PageLoader />}>
    <CustomHtmlEditorComponent {...props} />
  </Suspense>
);
